const initCourseRegistrationCompanySelection = () => {
    const form = document.querySelector('form[name="course_registration"]');
    if (!form)
        return;
    const companyDropdown = form.querySelector('.company-selection-dropdown');
    const notAvailableTextRow = form.querySelector('.company-not-available-text-row');
    const preselectedCompanyId = form.dataset.preselectedCompanyId;
    if (!companyDropdown || !notAvailableTextRow)
        return;
    // If company is preselected (from token), disable dropdown
    if (preselectedCompanyId) {
        companyDropdown.value = preselectedCompanyId;
        companyDropdown.disabled = true;
    }
    else {
        // Normal behavior: toggle text field based on selection
        const toggleNotAvailableField = () => {
            if (companyDropdown.value === '__not_available__') {
                notAvailableTextRow.style.display = 'block';
            }
            else {
                notAvailableTextRow.style.display = 'none';
            }
        };
        companyDropdown.addEventListener('change', toggleNotAvailableField);
        // Initialize on page load
        toggleNotAvailableField();
    }
};
export default initCourseRegistrationCompanySelection;
